import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import PageHeading from '../../components/page-heading'
import LoginForm from '../../components/login-form'
import { ConsumerSignUpLink } from '../../components/login-actions'

const LoginPage = () => {
  return (
    <Box mb={4}>
      <PageHeading
        heading="Log in with your MyPGA Account"
        subheading="The only account you'll ever need in golf"
      />
      <Box mb={4}>
        <LoginForm />
      </Box>
      <Box textAlign="center">
        <Typography variant="body1">
          Need an account?&nbsp;
          <ConsumerSignUpLink />
        </Typography>
      </Box>
    </Box>
  )
}

export default LoginPage
